import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Drawer } from 'rsuite';
import './HomePages/home.css';
import ugr from '@/UGRoute';
export default function NavDrawer({ open, close }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate(
      `/${ugr}/client/apptwo?Key=${sessionStorage.getItem('Key')}&id=${sessionStorage.getItem(
        'idParam'
      )}&Cat_id=${sessionStorage.getItem('Cat_id')}`
    );
    sessionStorage.clear();
  };
  return (
    <div>
      <Drawer open={open} onClose={close} >
        <Drawer.Header>
          <Drawer.Title>
            <div style={{ marginLeft: '10px' }}>
              <Link to={`/${ugr}/client/home-page`} style={{ textDecoration: 'none' }}>
                <div className="roboto-regular logo-name" style={Logostyle}>
                  <span style={{ fontSize: '40px' }} className="roboto-medium">
                    W
                  </span>
                  illiams Sonoma <span className="roboto-light">Home</span>
                </div>
              </Link>
            </div>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body style={{ position: 'relative' }}>
          <ul className="drawer-menu-list">
            <li onClick={() => close()}>
              <Link to={`/${ugr}/client/home-page`}>Home Page</Link>
            </li>
            <li onClick={() => close()}>
              <Link to={`/${ugr}/client/product`}>My Catalogue</Link>
            </li>
            <li onClick={() => close()}>
              <Link to="#">New Catalogue</Link>
            </li>
            <li onClick={() => close()}>
              <Link to={`/${ugr}/client/space-visualization`}>Space Visualization</Link>
            </li>
            <li onClick={() => close()}>
              <Link to={`/${ugr}/client/my-activity`}>My Activity</Link>
            </li>
          </ul>
          <div className="logout-btn">
            <button className="roboto-medium ">
              <span
                className="material-symbols-outlined"
                style={{ cursor: 'pointer' }}
                onClick={handleLogout}
              >
                logout
              </span>
              Logout
            </button>
          </div>
        </Drawer.Body>
      </Drawer>
    </div>
  );
}
const Logostyle = {
  fontSize: '32px',
  textTransform: 'capitalize',
  letterSpacing: '.07rem',
  color: '#005c80'
};
